


























































import Vue from 'vue';
import store from '@/store';
import DeleteButtonWithMessage from '@/components/DeleteButtonWithMessage.vue';
import { WebRequestStatus } from '@/models';
import { OrgUser } from '@/models/orgStructure';

export default Vue.extend({
  name: 'OrganizationUserSettings',
  components: {
    DeleteButtonWithMessage
  },
  props: {
    memberId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      newName: ''
    };
  },

  computed: {
    user(): OrgUser {
      return store.getters.org.user(this.memberId);
    },

    organizationId(): number {
      return store.state.org.basic.organizationId;
    },

    canDelete(): boolean {
      return store.getters.memberInfo.getMemberInfoById(this.memberId)
        .canDelete;
    },

    currentName(): string {
      return this.user.name || '';
    },

    canUpdateName(): boolean {
      return store.getters.org.canUpdateMemberName(this.memberId);
    },

    isNameValid(): boolean {
      const name = this.newName.trim();
      return name !== '' && name !== this.currentName;
    },

    isUpdatingName(): boolean {
      return (
        store.getters.org.status.user(this.memberId) ===
        WebRequestStatus.IN_PROGRESS
      );
    },

    updateNameError(): boolean {
      return (
        store.getters.org.status.user(this.memberId) ===
        WebRequestStatus.FAILURE
      );
    }
  },

  watch: {
    currentName: {
      immediate: true,
      handler(val) {
        this.newName = val || '';
      }
    }
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'OrganizationUser',
        params: {
          organizationId: `${this.organizationId}`,
          userId: `${this.memberId}`
        }
      });
    },

    async handleDelete() {
      const onDeleted = () => {
        this.$router.push({
          name: 'Organization',
          params: { organizationId: `${this.organizationId}` }
        });
      };

      await store.dispatch.org.deleteUser({
        memberId: this.memberId,
        beforeOrgReInit: onDeleted
      });
    },

    async handleNameUpdate() {
      if (!this.isNameValid) return;

      await store.dispatch.org.updateMemberName({
        memberId: this.memberId,
        name: this.newName.trim()
      });
    }
  },

  mounted() {
    store.dispatch.memberInfo.getMemberInfo({
      organizationId: this.organizationId,
      memberId: this.memberId
    });
  }
});
